import { createSelector } from 'reselect'

import { selectPartner360Data } from './selectPartner360Data'

export const selectActualsData = createSelector(
  [selectPartner360Data],
  ({ actualsData }) => actualsData
)
